import React from 'react'
import { BaseModalProps } from '@components/modals/types'
import { ModalBody } from 'react-bootstrap'
import { Popup } from '@models/popups'
import { getPopupGraphicType, PopupContent } from '@modules/package-wholesale/modals/popup-content'
import { PopupLink } from '@modules/package-wholesale/modals/popup-link'

interface Props extends BaseModalProps {
  popup: Popup
}
export const PopupsModal = ({ toggleIsVisible, popup }: Props): React.JSX.Element => {
  const content = (
    <PopupContent
      desktop={{ url: popup.image_desktop, type: getPopupGraphicType(popup.image_desktop) }}
      mobile={{ url: popup.image_mobile, type: getPopupGraphicType(popup.image_mobile) }}
    />
  )

  const renderBody = () => {
    if (popup.grid === 'single_row_single_column') {
      return popup.link_1 ? <PopupLink href={popup.link_1}>{content}</PopupLink> : content
    }

    if (popup.link_1 && popup.link_2 && popup.link_3) {
      return (
        <div className="position-relative">
          <div className="popup__single-row-three-column">
            <PopupLink href={popup.link_1}> </PopupLink>
            <PopupLink href={popup.link_2}> </PopupLink>
            <PopupLink href={popup.link_3}> </PopupLink>
          </div>
          {content}
        </div>
      )
    }

    return content
  }

  return (
    <ModalBody className="rounded bg-transparent border-0 p-0">
      <button type="button" onClick={toggleIsVisible} aria-label="Zamknij okno" className="popup__close-icon">
        <i className="uil-times" aria-hidden="true" />
      </button>
      {renderBody()}
    </ModalBody>
  )
}
